import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from "react-router-dom";
import cdpp_blanc from "./Resources/pictogrammes/cdpp_blanc.svg";
import logotbm from "./Resources/tbm.svg";
import condor from "./Resources/condor.svg";
import faireundonnoir from "./Resources/pictogrammes/faireundonnoir.svg";
import lists from "./files/carousels.json";
import vars from "./files/vars.json";
import instagram from "./Resources/pictogrammes/instagram.svg";
import facebook from "./Resources/pictogrammes/facebook.svg";
import youtube from "./Resources/pictogrammes/youtube.svg";
import iti from "./Resources/pictogrammes/googlemaps.svg"

const col_small = "col-sm-4";
const col_large = "col-sm-8";
const col_image = "col-sm-4 img hideinmobile";

function FctTitre({ article }) {
    return article.titre ? (
        <div>
            <h3 style={{ textAlign: "center" }}>{article.titre}</h3>
        </div>
    ) : null;
}

function Titre({ libelle, color, image, classTitle }) {
    const imagesMap = {
        cddp: cdpp_blanc,
        logotbm: logotbm,
        default: condor
    };

    return (
        <div className="xrow rowtitle run-rotation">
            <div className={`title col card-prog ${color} ${classTitle}`}>
                <h1>
                    {libelle}
                    {image === "carousel" ? <Carousel /> : <img className="title-img" src={imagesMap[image] || imagesMap.default} alt="" />}
                </h1>
            </div>
        </div>
    );
}

function FaireunDon() {
    return (
        <button className="btn discret faireundonmobile">
            <a target="_blank" rel="noopener noreferrer" href={vars.url_faireundon}>
                <img src={faireundonnoir} width="100px" alt="Faire un don" className="faireundon" />
            </a>
        </button>
    );
}

function FaireunDonNoir() {
    return (
        <button className="btn discret inmenu">
            <a target="_blank" rel="noopener noreferrer" href={vars.url_faireundon}>
                <img id="faireundon" src={faireundonnoir} alt="Faire un don" className="faireundon" />
            </a>
        </button>
    );
}

function LienPhotos({ titre, link }) {
    return (
        <div className="col card-prog">
            <h2>
                <a target="_blank" rel="noopener noreferrer" href={link}>{titre}</a>
            </h2>
        </div>
    );
}

function LienVideo({ image, link }) {
    return (
        <div className="col card-prog white">
            <a target="_blank" rel="noopener noreferrer" href={link}>
                <img className="LienVideo" src={image} alt="Vidéo" />
            </a>
        </div>
    );
}

function Carousel() {
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const images = lists["podium"];

    useEffect(() => {
        const intervalId = setInterval(() => {
            setCurrentImageIndex(prevIndex => (prevIndex + 1) % images.length);
        }, 3000);

        return () => clearInterval(intervalId);
    }, [images.length]);

    return (
        <div id="carouselPodium">
            <img src={process.env.PUBLIC_URL + images[currentImageIndex]} alt={`carouselPodium ${currentImageIndex + 1}`} className="carousel-image" />
        </div>
    );
}

function UseGTMPageView() {
    const location = useLocation();

    useEffect(() => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "page_view",
            pagePath: location.pathname,
            pageTitle: document.title,
        });
    }, [location]);
}

function Gafams() {
    return (
        <>
            <a target="_blank" rel="noopener noreferrer" href={vars.gafams.instagram}>
                <img src={instagram} alt="Instagram" width="40px" />
            </a>
            <a target="_blank" rel="noopener noreferrer" href={vars.gafams.facebook}>
                <img src={facebook} alt="Facebook" width="40px" />
            </a>
            <a target="_blank" rel="noopener noreferrer" href={vars.gafams.youtube}>
                <img src={youtube} alt="YouTube" width="40px" />
            </a>
        </>
    );
}


function CompteurDiv({ timeLeft, what }) {
    if (what === "mois"  && timeLeft.months >=1) {
        return (
            <div>{timeLeft.months}<span>Mois</span></div>
        )
    }
    if (what === "days" && timeLeft.days) {
        return (
            <div className="days">{timeLeft.days}<span>Jours</span></div>
        )
    }
    if (what === "hours" && timeLeft.hours) {
        return (
            <div className="hours">{timeLeft.hours}<span>Heures</span></div>
        )
    }
    if (what === "minutes" && timeLeft.minutes) {
        return (
            <div className="seconds">{timeLeft.minutes}<span>Minutes</span></div>
        )
    }
    if (what === "seconds") {
        return (
            <div className="seconds">{timeLeft.seconds}<span>Secondes</span></div>
        )
    }
}
function CountdownTimer({ targetDate }) {
    const calculateTimeLeft = () => {
        const now = new Date();
        // const targetx = new Date(targetDate);
        const target = new Date(targetDate);

        if (target <= now) return null;

        const totalSeconds = Math.floor((target - now) / 1000);

        // Calcul des unités
        const seconds = totalSeconds % 60;
        const minutes = Math.floor((totalSeconds / 60) % 60);
        const hours = Math.floor((totalSeconds / 3600) % 24);
        const days = Math.floor((totalSeconds / 86400) % 30.44);
        const nmonths = now.getMonth() +1;
        const months = Math.floor((target.getFullYear() - now.getFullYear()) * 12 + (target.getMonth() - nmonths));
        const x = target.getMonth()
        return { months, days, hours, minutes, seconds, x, nmonths };
    };

    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

    useEffect(() => {
        const timer = setInterval(() => {
            setTimeLeft(calculateTimeLeft());
        }, 1000);

        return () => clearInterval(timer);
    }, [targetDate]);

    return (
        <div className='compteur'>
            {timeLeft ? (
                <>
                    <CompteurDiv timeLeft={timeLeft} what="mois" />
                    <CompteurDiv timeLeft={timeLeft} what="days" />
                    <CompteurDiv timeLeft={timeLeft} what="hours" />
                    {/* <CompteurDiv timeLeft={timeLeft} what="minutes" /> */}
                    {/* <CompteurDiv timeLeft={timeLeft} what="seconds" /> */}
                </>
            ) : (
                <span>⏰ Temps écoulé !</span>
            )}
        </div>
    );
};

function GoogleMaps({ keymaps }) {
    const href = vars["maps"][keymaps]
    return (
        <>
            < a href={href} target='_blank'><img src={iti} /></a>
        </>
    )
}

function CoursesTerminees() {
    const [data, setData] = useState({});

    useEffect(() => {
        fetch(`/documents/resultats.json?nocache=${Date.now()}`)
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Erreur de chargement du fichier resultats.json');
                }
                return response.json();
            })
            .then((jsonData) => setData(jsonData))
            .catch((error) => console.error('Erreur lors du fetch:', error));
    }, []);

    const activeResults = data.activeResults;
    // const activeResults = Object.entries(data).filter(([key, value]) => value.activate);
    return activeResults === "true"
}

function Counts() {
    const [data, setData] = useState({});

    useEffect(() => {
        fetch(`/documents/inscriptions.json?nocache=${Date.now()}`)
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Erreur de chargement du fichier inscriptions.json');
                }
                return response.json();
            })
            .then((jsonData) => setData(jsonData))
            .catch((error) => console.error('Erreur lors du fetch:', error));
    }, []);

    return data.counts
}



function SvgAnimation({ id, duration }) {
    const trajectoireRef = useRef(null);
    const ballonRef = useRef(null);

    useEffect(() => {
        const path = trajectoireRef.current;
        const ballon = ballonRef.current;

        if (!path || !ballon) return;
        const bbox = ballon.getBBox();
        const anchorX = bbox.x + bbox.width / 2;
        const anchorY = bbox.y + bbox.height;

        const totalLength = path.getTotalLength();
        let start = null;
        let animationFrame;

        const animate = (timestamp) => {
            if (!start) start = timestamp;
            const elapsed = timestamp - start;

            const duration_ = duration * 2000;
            const progress = (elapsed % duration_) / duration_;

            const t = Math.min(progress, 1);
            const point = path.getPointAtLength(progress * totalLength);

            const x = point.x;
            const y = point.y;
            const scale = t < 0.5 ? t * 2 : (1 - t) * 2;
            const dx = x - anchorX * scale;
            const dy = y - anchorY * scale;

            ballon.setAttribute(
                'transform',
                `translate(${dx}, ${dy}) scale(${scale})`
            );
            animationFrame = requestAnimationFrame(animate);
        };

        animationFrame = requestAnimationFrame(animate);
        return () => cancelAnimationFrame(animationFrame);
    }, []);

    return (
        <>
            <svg id="svg17219" width="260" height="204.71063" version="1.1" viewBox="10 -20 250 204.71063" xmlns="http://www.w3.org/2000/svg">

                <path id="trace" d="m175.29 189.11c-8.3502-1.8783-11.609-7.6487-7.9696-14.111 2.7281-4.8441 11.657-5.8199 20.677-2.2598 3.9209 1.5475 5.3109 4.3499 4.7958 9.669-.76639 7.9144-4.965 9.522-17.503 6.7018zm35.36.22c-4.5088-2.681-3.6034-11.067 1.6414-15.204 4.8653-3.837 16.942.5463 16.942 6.1491 0 8.8661-10.388 13.928-18.584 9.0545zm-84.43-6.32c-5.3502-9.4997.4627-14.939 13.589-12.717 9.4542 1.6009 11.493 3.1998 11.493 9.0132 0 5.887-1.8369 7.243-11.001 8.1206-7.6893.73643-11.928-.59307-14.082-4.4169zm-32.466-1.56c-7.5069-1.6817-9.5916-3.6847-9.5916-9.2158 0-5.7158 1.8339-7.266 9.5916-8.1073 12.291-1.3331 20.536 6.3853 15.802 14.792-1.7602 3.1254-3.8776 5.457-4.7053 5.1812-.82763-.27594-5.821-1.4683-11.096-2.6502zm-41.963-12.38c-8.9397-4.8214-12.373-14.917-6.2511-18.379 2.0322-1.1492 8.3165.18074 13.965 2.9552 7.332 3.6015 10.27 6.9822 10.27 11.817 0 8.4038-6.6256 9.7324-17.984 3.6064zm-27.171-25.69c-2.4483-3.6077-1.9002-22.013.88368-29.678 1.3652-3.7591 4.6685-6.8348 7.3406-6.8348 4.4291 0 4.7124 1.4829 3.2069 16.784-.90828 9.2313-2.1171 17.977-2.6863 19.434-1.2828 3.2848-6.5942 3.4637-8.7449.29433zm23.913-41.81c-1.8233-7.0017 7.081-15.387 17.7-16.668 7.0064-.84547 8.4596.2288 9.0876 6.7183.60879 6.29-.94966 8.4192-8.3912 11.464-12.433 5.0878-16.771 4.7308-18.397-1.5142zm40.525-12.15c-.93858-2.2379-.4089-6.373 1.1771-9.1891 3.395-6.028 20.579-13.501 23.961-10.421 3.3022 3.0074 2.9092 10.759-.77379 15.263-4.8818 5.9703-22.375 9.0913-24.365 4.347zm29.282-37.14c-7.8642-14.524-8.494-23.157-1.6894-23.157 5.5067 0 16.676 14.803 16.676 22.101 0 4.7228-4.5496 13.235-7.0738 13.235-.72536-7e-5-4.2862-5.4804-7.9131-12.179zm-40.911-18.64c-5.3191-1.1782-6.5817-3.1133-5.9947-9.1878.65785-6.8086 2.0958-7.6243 12.479-7.0795 12.207.64049 17.452 6.3982 13.011 14.283-2.5274 4.4876-6.4093 4.8827-19.496 1.984zm-39.157-6.29c-2.1245-8.1584 2.1836-13.104 10.234-11.748 5.0254.84626 6.8863 3.0694 6.8863 8.2267 0 9.3636-14.806 12.409-17.12 3.5217z" fill="#2b95d0" />
                <path id="trajectoire" d="m43.752 6.2672c20.031.23839 41.269-2.2205 59.916 6.3265 14.78-.68478 29.252 14.228 23.361 28.037-5.2436 14.7-21.76 22.017-36.534 25.767-20.739 3.4382-41.981 11.35-55.848 26.862-10.579 13.236-3.6045 33.07 9.8266 42.091 16.282 8.9785 33.61 16.589 51.703 21.812 18.525 5.3446 37.89 7.1659 56.991 9.7552 20.946 2.1817 42.198 2.9643 63.163.64654 11.863-3.6658-13.832-5.09-20.769-2.7777-23.866-2.0723-39.962.26797-63.736-2.5975-21.513-6.1891-40.951-9.3444-61.841-17.791-13.897-1.7704-28.522-10.903-30.324-24.913-7.3664-10.595-6.3658-28.31 6.9761-34.253 19.434-8.7021 44.8-14.648 59.679-22.896 14.408-6.6953 16.117-9.5032 15.687-25.46.44568-9.0952-3.6566-19.946-14.079-22.095-20.018-7.1042-41.999-3.338-62.45-8.4684l-1.7231-.0457z" fill="none" ref={trajectoireRef} />
                <g id="g17215" ref={ballonRef}>
                    <path id="ballon" d="m49.064.00061845c-24.744-.15104-49.064 27.375-49.064 69.892 0 22.011 8.8733 48.451 30.182 89.927v.005c8.7368 17.005 16.778 30.917 17.869 30.917s9.1059-13.912 17.811-30.917c33.812-66.054 38.665-100.54 18.998-134.98-9.7587-17.09-22.836-24.764-35.797-24.843zm1.2189 40.375c9.1208.21148 16.671 12.949 17.469 29.47.85669 17.74-6.3462 33.394-16.101 34.992l-.1632.0248c-9.7624 1.4347-18.322-11.768-19.133-29.515-.8118-17.747 6.4303-33.34 16.189-34.856.57862-.09 1.1593-.12827 1.74-.1148z" fill="rgb(255, 208, 0)" stroke-width="2.9108" />
                </g>
            </svg>
        </>
    );
}

function Video({ file, className = "video" }) {

    return (
        <div className="xvideo mx-auto p-4" style={{ textAlign: "center" }}>
            <video
                src={process.env.PUBLIC_URL + '/videos/' + file} alt={file}
                className={`w-full object-cover rounded-xl ${className}`}
                autoPlay
                loop
                muted
                controls
            />
        </div>
    );
};


function ToggleImage({
    buttonText,
    buttonClass,
    imageDesktop,
    imageMobile,
    imageAlt = "image"
}) {
    const [visible, setVisible] = useState(false);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        checkMobile();
        window.addEventListener("resize", checkMobile);

        return () => window.removeEventListener("resize", checkMobile);
    }, []);
    const imageSrc = isMobile ? imageMobile : imageDesktop;

    return (
        <div className="toggleImage">
            <button
                className={buttonClass}
                onClick={() => setVisible(!visible)}
            >
                {buttonText}
            </button>

            {visible && (
                <img
                    src={imageSrc}
                    alt={imageAlt}
                    style={{ marginTop: "10px", width: "100%" }}
                />
            )}
        </div>
    );
}

export default ToggleImage;


export { Titre, FaireunDon, LienPhotos, LienVideo, FctTitre, FaireunDonNoir, UseGTMPageView, Gafams, CountdownTimer, GoogleMaps, CoursesTerminees, Counts, SvgAnimation, col_large, col_small, col_image, Video, ToggleImage };
